<script setup>
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/AdminLayout.vue";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Message from 'primevue/message';
import { ref, computed } from "vue";
import { useToast } from "primevue/usetoast";
import AdminUserFields from "../Components/AdminUserFields.vue";

const props = defineProps([
    'flash',
    'roleOptions',
]);

const toast = useToast();

const errors = ref({})

const form = useForm({
    email: null,
    password: null,
    password_confirmation: null,
    role: null,
    forename: null,
    surname: null,
    phone: null,
    mobile: null,
});

const submit = () => {
    errors.value = {}

    form.post('/admin/users', {
        preserveState: true,

        onSuccess: () => {
        },

        onError: (errorsResponse) => {
            errors.value = errorsResponse

            form.password = null
            form.password_confirmation = null
        }
    })
}

const hasErrors = computed(() => {
    return Object.keys(errors.value).length > 0
})

</script>

<template>
    <Layout :flash="flash">
        <Head title="Admin Benutzer Hinzufügen" />

        <div class="py-7 px-14 text-sm">
            <h1 class="text-black text-lg font-bold mb-9">
                Benutzer Hinzufügen
            </h1>

            <Message v-if="hasErrors" severity="error">
                <div v-for="(data, key) in errors">{{ data[0] }}</div>
            </Message>

            <form @submit.prevent="submit">
                <AdminUserFields :form="form" :role-options="roleOptions"></AdminUserFields>

                <div class="flex justify-between">
                    <div>
                        <Button
                            asChild
                            v-slot="slotProps"
                            severity="secondary"
                            type="button"
                            class="!border-none">
                            <Link href="/admin/users" :class="slotProps.class">Zurück</Link>
                        </Button>
                    </div>

                    <div>
                        <Button
                            label="Speichern"
                            class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                            type="submit"
                            :disabled="form.processing"
                            :loading="form.processing"
                        />
                    </div>
                </div>
            </form>
        </div>
    </Layout>
</template>
